import React from "react";

export const RideCardBodySeparator = () => {
  return <div className="ride-card-body-separator" data-testid="body-separator" />;
};
